import template from './sw-cms-sidebar.html.twig';
import './sw-cms-sidebar.scss';

export default {
    template,

    data() {
        return {
            sectionHeaderWrapperClass: 'sw-cms-sidebar__navigator-section-header-wrapper',
        };
    },

    computed: {
        sectionHeaderWrapperClasses() {
            return [this.sectionHeaderWrapperClass];
        },

        /**
         * @deprecated tag:v6.0.0 - Will be removed
         */
        scrollNavigationFeatureActive() {
            return true;
        },
    },

    watch: {
        'cmsPageState.currentPage'() {
            Shopware.Store.get('cmsPage').removeSelectedSection();
        },
    },

    methods: {
        getScrollNavigationBySection(section) {
            return section.extensions.swagCmsExtensionsScrollNavigation;
        },

        scrollNavigationIsActive(section) {
            return this.getScrollNavigationBySection(section)?.active;
        },

        navigatorSectionHeaderWrapperClass(section) {
            return this.getScrollNavigationBySection(section)?.active ? [this.sectionHeaderWrapperClasses] : '';
        },

        scrollNavigationAnchorTooltip(section) {
            const scrollNavigation = this.getScrollNavigationBySection(section);
            const message = scrollNavigation?.displayName.length > 0 ?
                scrollNavigation.displayName :
                this.$tc('swag-cms-extensions.sw-cms.sidebar.emptyAnchorName');

            return {
                message,
            };
        },
    },
}
